import { jsx as _jsx } from "react/jsx-runtime";
import { Renderer_SearchResult } from '@app/styles';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { EditableDBItemV3 } from '@nu-art/thunderstorm-frontend';
import { Editor_FlowSheet } from './Editor_FlowSheet/Editor_FlowSheet.js';
import { Editor_NoteTemplate } from './Editor_NoteTemplate/Editor_NoteTemplate.js';
import { Editor_LogTemplate } from './Editor_LogTemplate/Editor_LogTemplate.js';
import { DBDef_FlowSheet, DBDef_LogTemplate, DBDef_NoteTemplate } from '@app/advisor-content-shared';
import { ModuleFE_NoteTemplate } from '../../_entity/note-template/ModuleFE_NoteTemplate.js';
import { ModuleFE_LogTemplate } from '../../_entity/log-tempalte/ModuleFE_LogTemplate.js';
import { ModuleFE_FlowSheet } from '../../_entity/flow-sheet/ModuleFE_FlowSheet.js';
export const SearchableItem_FlowSheet = {
    type: DBDef_FlowSheet.dbKey,
    module: ModuleFE_FlowSheet,
    entityName: DBDef_FlowSheet.entityName,
    entityLabel: DBDef_FlowSheet.entityName,
    route: { key: 'smart-doc' },
    groupId: ['Smart Docs'],
    mapper: item => [item.label],
    tags: [],
    renderer: (doc, selected, onClickCallback) => {
        return _jsx(Renderer_SearchResult, { itemId: doc._id, itemKey: DBDef_FlowSheet.dbKey, itemLabel: doc.label, entityLabel: DBDef_FlowSheet.entityName, hierarchy: 'Smart Docs', selected: selected, onClickCallback: onClickCallback });
    },
    resultRenderer: (id) => {
        const flowSheet = ModuleFE_FlowSheet.cache.unique(id);
        if (!flowSheet)
            throw new MUSTNeverHappenException(`Could not find a flow sheet for the given id ${id}`);
        const editable = new EditableDBItemV3(flowSheet, ModuleFE_FlowSheet);
        return _jsx(Editor_FlowSheet, { editable: editable });
    }
};
export const SearchableItem_NoteTemplate = {
    type: DBDef_NoteTemplate.dbKey,
    module: ModuleFE_NoteTemplate,
    entityName: DBDef_NoteTemplate.entityName,
    entityLabel: DBDef_NoteTemplate.entityName,
    route: { key: 'smart-doc' },
    groupId: ['Smart Docs'],
    mapper: item => [item.label],
    tags: [],
    renderer: (doc, selected, onClickCallback) => {
        return _jsx(Renderer_SearchResult, { itemId: doc._id, itemKey: DBDef_NoteTemplate.dbKey, itemLabel: doc.label, entityLabel: DBDef_NoteTemplate.entityName, hierarchy: 'Smart Docs', selected: selected, onClickCallback: onClickCallback });
    },
    resultRenderer: (id) => {
        const noteTemplate = ModuleFE_NoteTemplate.cache.unique(id);
        if (!noteTemplate)
            throw new MUSTNeverHappenException(`Could not find a note template for the given id ${id}`);
        const editable = new EditableDBItemV3(noteTemplate, ModuleFE_NoteTemplate);
        return _jsx(Editor_NoteTemplate, { editable: editable });
    }
};
export const SearchableItem_LogTemplate = {
    type: DBDef_LogTemplate.dbKey,
    module: ModuleFE_LogTemplate,
    entityName: DBDef_LogTemplate.entityName,
    entityLabel: DBDef_LogTemplate.entityName,
    route: { key: 'smart-doc' },
    groupId: ['Smart Docs'],
    mapper: item => [item.label],
    tags: [],
    renderer: (doc, selected, onClickCallback) => {
        return _jsx(Renderer_SearchResult, { itemId: doc._id, itemKey: DBDef_LogTemplate.dbKey, itemLabel: doc.label, entityLabel: DBDef_LogTemplate.entityName, hierarchy: 'Smart Docs', selected: selected, onClickCallback: onClickCallback });
    },
    resultRenderer: (id) => {
        const logTemplate = ModuleFE_LogTemplate.cache.unique(id);
        if (!logTemplate)
            throw new MUSTNeverHappenException(`Could not find a log template for the given id ${id}`);
        const editable = new EditableDBItemV3(logTemplate, ModuleFE_LogTemplate);
        return _jsx(Editor_LogTemplate, { editable: editable });
    }
};
export const getSearchableItems_SmartDocs = () => [SearchableItem_FlowSheet, SearchableItem_NoteTemplate, SearchableItem_LogTemplate];
//# sourceMappingURL=searchable-items.js.map